// Static demo-mode fill-in data for TeamsTimeline.component.jsx (Department
// Timeline). Shape matches exactly what `rows` state holds and what
// TeamsTimeline.config.jsx's `teamsTimelineColumnConfig` cell renderers read
// per row: `{ userUID, userName, timeZone, checkIn, checkOut, workSec,
// productiveSec, idleSec, lastActivityAt }`.
//
// Unlike Timeline.demoData.js's fixed timestamps, `lastActivityAt` here
// feeds a live "Active"/"Inactive" status computed as
// `Date.now() - lastActivityAt <= 6 minutes` (see `isActiveByLastActivity`
// in both the component and the column config). A hardcoded past timestamp
// would read as "Active" only for the first few minutes after being
// authored and then permanently flip to "Inactive". So this is a builder
// function, called fresh whenever the demo data is (re)applied — on mount,
// on date-picker change, and on manual "Apply"/status-refresh clicks — so
// most rows always land inside the active window and a couple stay stale
// ("Inactive"), matching a realistic mostly-active team.

const HOUR_MS = 60 * 60 * 1000;
const MIN_MS = 60 * 1000;

const ROW_TEMPLATES = [
  {
    userUID: 'demo-user',
    userName: 'Ryan Mitchell',
    timeZone: 'America/New_York',
    checkInHoursAgo: 6,
    workSec: 21600,
    productiveSec: 18500,
    idleSec: 3100,
    lastActivityMinAgo: 2,
  },
  {
    userUID: 'demo-user-2',
    userName: 'Rachel Turner',
    timeZone: 'America/Denver',
    checkInHoursAgo: 7.5,
    workSec: 25200,
    productiveSec: 22000,
    idleSec: 3200,
    lastActivityMinAgo: 1,
  },
  {
    userUID: 'demo-user-3',
    userName: 'Michael Chen',
    timeZone: 'America/Los_Angeles',
    checkInHoursAgo: 5,
    workSec: 18000,
    productiveSec: 15400,
    idleSec: 2600,
    lastActivityMinAgo: 3,
  },
  {
    userUID: 'demo-user-4',
    userName: 'Sarah Johnson',
    timeZone: 'Europe/London',
    checkInHoursAgo: 6.5,
    workSec: 20700,
    productiveSec: 17600,
    idleSec: 3100,
    lastActivityMinAgo: 4,
  },
  {
    userUID: 'demo-user-5',
    userName: 'Fatima Al-Sayed',
    timeZone: 'Asia/Dubai',
    checkInHoursAgo: 8,
    checkOutHoursAgo: 0.5,
    workSec: 27000,
    productiveSec: 23500,
    idleSec: 3500,
    lastActivityMinAgo: 32,
  },
  {
    userUID: 'demo-user-6',
    userName: 'David Kim',
    timeZone: 'Asia/Singapore',
    checkInHoursAgo: 4,
    workSec: 14400,
    productiveSec: 12100,
    idleSec: 2300,
    lastActivityMinAgo: 2,
  },
  {
    userUID: 'demo-user-7',
    userName: 'Emma Williams',
    timeZone: 'Australia/Sydney',
    checkInHoursAgo: 9,
    checkOutHoursAgo: 1,
    workSec: 28800,
    productiveSec: 24900,
    idleSec: 3900,
    lastActivityMinAgo: 68,
  },
];

export const buildDemoTeamsTimelineRows = () => {
  const now = Date.now();
  return ROW_TEMPLATES.map((t) => ({
    userUID: t.userUID,
    userName: t.userName,
    timeZone: t.timeZone,
    checkIn: new Date(now - t.checkInHoursAgo * HOUR_MS),
    checkOut:
      t.checkOutHoursAgo != null
        ? new Date(now - t.checkOutHoursAgo * HOUR_MS)
        : null,
    workSec: t.workSec,
    productiveSec: t.productiveSec,
    idleSec: t.idleSec,
    lastActivityAt: new Date(now - t.lastActivityMinAgo * MIN_MS),
  }));
};
